import React from "react";
import { Col } from "react-bootstrap";
import CommonMap from "../maps/CommonMap.js";
import { withCommonMapProvider } from "../../utils/withCommonMapProvider.js";

const MiniMap = ({ width, name, children }) => {
  return (
    <React.Fragment>
      <Col
        key={name}
        lg={((width / 100) * 12).toFixed(0)}
        className="position-relative mb-4"
      >
        <CommonMap
          height="60vh"
          showGoogleSearch={true}
          showNearByAssets={true}
          showTrackingSearch={true}
          showHashTagFilter={true}
          showCategoryFilter={true}
        />
      </Col>
    </React.Fragment>
  );
};

export default withCommonMapProvider(MiniMap);
